import React, { useState, useEffect } from 'react';
import Network from '../../../models/Network.js';
import SchematronListElement from '../list_elements/SchematronListElement.js';
import './Module.css';

const key = process.env.REACT_APP_CLIENT_ACCESS_KEY;
const URLS = require("../../../urls.js");

const StatusCodes = require('../../../status-codes/status-codes.js');
const ErrorCodes = require('../../../error-codes/error-codes.js');

const SchematronModule = ({ user, reportId, isSmallScreen }) => {
    const [errorData, setErrorData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Function to get schematron rules for a report
    const getOneReportSchematron = async (reportId) => {
        const url = URLS.GET_ONE_REPORT_SCHEMATRON;
        const dict = {
            report_id: reportId,
            CLIENT_ACCESS_KEY: key
        };
        let responseData;

        try {
            await Network.post(url, dict, (response) => {
                responseData = response.data;
                const status = response.status;

                if (Network.checkValidStatusAndResponse(response)) {
                    setErrorData(responseData);
                    setError(null);
                } else if (status === StatusCodes.INTERNAL_SERVER_ERROR) {
                    setError("Server Error");
                } else {
                    setError("Unknown Error");
                }
                setLoading(false);
            });
        } catch (err) {
            setError("Failed to fetch schematron rules");
            setLoading(false);
        }
        return responseData;
    };

    useEffect(() => {
        if (reportId) {
            setLoading(true);
            getOneReportSchematron(reportId)
                .catch((error) => {
                    setError("Error fetching schematron rules");
                    setLoading(false);
                });
        }
    }, [reportId]);

    const createErrorListElement = (data) => {
        return (
            <SchematronListElement
                key={data.schematron_id}
                errorData={data}
            />
        );
    };

    return (
        <div className={isSmallScreen ? "standard-module-screen-small" : "standard-module"}>
            <div>
                <h2 className='module-title'>Schematron Validation</h2>
                {loading ? (
                    <div>Loading Schematron Rules...</div>
                ) : error ? (
                    <div className="error-message">{error}</div>
                ) : errorData ? (
                    errorData.length > 0 ? (
                        <div>
                            {errorData.map((rule) => createErrorListElement(rule))}
                        </div>
                    ) : (
                        <div>No schematron rules found for this report</div>
                    )
                ) : null}
            </div>
        </div>
    );
};

export default SchematronModule; 